import FormattedMessage from 'I18n/components/FormattedMessage';
import { LAYOUT_TYPES } from '../../editorCapabilities/toolbarCustomization';
import editorCapabilities, { BLOCKQUOTE, BOLD, CLEAR_FORMATTING, FILE_ATTACHMENTS, FONT_SIZE, FONT_STYLE, INLINE_IMAGE, PERSONALIZATION_TOKEN, INVOICES, ITALIC, KNOWLEDGE_ARTICLE, LINK, LISTS, MEETINGS, PAYMENT_LINK, RENDER_SUBMIT_BUTTON, RENDER_TRAY, SNIPPETS, STRIKETHROUGH, TEMPLATES, TEXT_ALIGN, TEXT_COLOR, TEXT_HIGHLIGHT, UNDERLINE, VIDEO_CONFERENCE_LINK, VIDEO_INSERTION, DRAFT_NOT_SAVED } from '../../editorCapabilities';
import { INSERT_CAPABILITIES } from '../partials/InsertMenuCapabilities';

/**
 * @description The toolbar layout for the default editor.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const defaultToolbarLayout = [BOLD, ITALIC, UNDERLINE, CLEAR_FORMATTING, {
  key: 'extra-fonts-dropdown',
  layoutType: LAYOUT_TYPES.DROPDOWN,
  buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "hubspot-prosemirror.buttons.styleDropdown"
  }),
  children: [FONT_STYLE, FONT_SIZE, TEXT_COLOR, TEXT_HIGHLIGHT, STRIKETHROUGH, {
    layoutType: LAYOUT_TYPES.DIVIDER,
    key: 'dropdown-divider-1'
  }, BLOCKQUOTE, LISTS, TEXT_ALIGN]
}, {
  layoutType: LAYOUT_TYPES.DIVIDER,
  key: 'layout-divider-key-1'
}, LINK, editorCapabilities.EMOJI, editorCapabilities.HORIZONTAL_RULE, INLINE_IMAGE, KNOWLEDGE_ARTICLE, SNIPPETS, MEETINGS, TEMPLATES, {
  key: 'prosemirror-insert-menu',
  layoutType: LAYOUT_TYPES.INSERT_MENU,
  children: INSERT_CAPABILITIES
}, VIDEO_CONFERENCE_LINK, FILE_ATTACHMENTS, DRAFT_NOT_SAVED, editorCapabilities.CONTENT_ASSISTANT, editorCapabilities.AI_ASSISTANT, VIDEO_INSERTION, {
  layoutType: LAYOUT_TYPES.SPACER,
  key: 'spacer-key-1'
}, RENDER_TRAY, RENDER_SUBMIT_BUTTON, PAYMENT_LINK, INVOICES, PERSONALIZATION_TOKEN, DRAFT_NOT_SAVED];

/**
 * @description The formatting tray layout for the default editor. Empty because the default
 * editor does not use the formatting tray.
 */
export const defaultFormattingTrayLayout = [];